import common from './common.json';
import error from './error.json';


const en = {
  common,
  error,
}

export default en;